export const SOFTWARE_DEVELOPMENT = 'Custom Software Development';
export const GC_MIGRATION = 'Migration to Google Cloud';
export const CDAP = 'CDAP Support';
export const BIG_DATA = 'Big Data Analytics';
export const GC_DATA_FUSION = 'Google Cloud Data Fusion';
export const SYSTEM_SUPPORT = 'System Support';
export const DEVOPS_SERVICES = 'DevOps as a Service';
export const IOT_DEVELOPMENT = 'IoT Development';
